import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'hero-info',
  template: `
    <div class="overlay-background">
      <div class="wrapper">
        <div class="hero-info">
          <div class="content">
            <ng-content></ng-content>
          </div>
          <div class="actions">
            <button class="btn btn-hero btn-hero-primary btn-small" (click)="close.emit()">Close</button>
          </div>
        </div>
      </div>
    </div>`,
  host: {
    class: 'hero-overlay'
  },
  standalone: true,
  imports: [],
})
export class HeroInfoComponent {
  @Output() public close = new EventEmitter();
}
